const components =  {
    meilisearch: {
        search: { placeholder: "Suche" },
        contacts: {
            search: { 
                buttons: { add: "Kontakt hinzufügen" },
            },
        }
    },
    contacts: {
        types: {
            external_collaborator: "Externer Mitarbeiter",
            provider: "Lieferant",
            customer: "Kunde"
        }
    }
};

export default components;